import axios from "axios";
import { API_URL } from "../config/api";

class ClientService {
  getAppointment(id) {
    return axios.get(API_URL + `confirm/${id}/`);
  }

  confirmAppointment(id, data) {
    return axios.post(API_URL + `confirm/${id}/`, data);
  }

  checkCancelAppointment(id) {
    return axios.get(API_URL + `cancel/${id}/`);
  }

  cancelAppointment(id) {
    return axios.post(API_URL + `cancel/${id}/`);
  }
}

export default new ClientService();
